import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import poDownloadRequest from "requests/poDownloadRequest";
import Loading from "components/Loading";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";

import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Container,
  FormFeedback,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Button,
  ButtonGroup,
  Col,
  Row,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
} from "reactstrap";

import "./style.css";

var FileSaver = require('file-saver');

const PoDownload = () => {
  const navigate = useNavigate();
  const [signatures, setSignatures] = useState([]);
  const [ signature , setSignature ] = useState(null);
  const [ file , setFile ] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    poDownloadRequest
      .getSignatures()
      .then((resp) => {
        setSignatures(resp);
        setLoading(false);
      })
      .catch((err) => console.error(err));
  }, []);

  function handleDownload(){

    setIsDownloading(true);

    toast.promise( poDownloadRequest.download(signature , file) , {
      loading: "Baixando arquivo...",
      success: "Sucesso",
      error: "Não foi possível baixar o arquivo"
    }).then((resp , other) => {


          const contentDisposition = resp.headers?.['content-disposition'];
          let fileName = 'Retorno.xlsx';

          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/i);
            if (fileNameMatch && fileNameMatch.length === 2) {
              fileName = fileNameMatch[1];
            }
          }

          FileSaver.saveAs(resp.data, fileName);
          setIsDownloading(false);
      })
      .catch((err) => {
        setIsDownloading(false);
        console.error(err);
      });
  }

  return (
    <div className="integrations-container">
      <div className="card-title-container">
        <h3 className="card-title">Po Download</h3>
      </div>
      <div className="table-container">
        {signatures?.length < 1 ? (
          <span className="nullable-table">
            {loading ? (
              <Loading message={"carregando integrações..."} />
            ) : (
              <h3 className="nullable-table">Nenhum modelo encontrado!</h3>
            )}
          </span>
        ) : (
          <>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleDownload();
              }}
            >
              <FormGroup className="mt-2">
                <Label for="signature">
                  <b>Leitor:</b>
                </Label>
                <Input
                  type="select"
                  id="signature"
                  onChange={(e) => setSignature(e.target.value)}>
                  <option value={null}><i>Selecione um leitor</i></option>
                  {signatures.map(s => {
                    return <option value={s}>{s}</option>
                  })}
                </Input>
              </FormGroup>
              <FormGroup className="mt-2">
                <Label for="file">
                  <b>Arquivo</b>
                </Label>
                <Input
                  id="file"
                  type="file"
                  className="form-control"
                  onChange={(e) => setFile(e.target.files[0])}>
                </Input>
              </FormGroup>
              {isDownloading ? <Loading  className="mt-4" message={"processando arquivo..."} />: 
              <FormGroup  className="mt-4">
                <Button
                  type="submit"
                  id="user-save-button"
                  style={{
                    color: "white",
                    background: "var(--COLOR_1)",
                    gridColumn: 2,
                  }}
                >
                  Download
                </Button>

              </FormGroup>}
            </Form>
          </>
        )}
      </div>
    </div>
  );
};

export default PoDownload;
